import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import EarningReleaseListDisplay from './EarningReleaseListDisplay';

class EarningReleaseWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Earning Release Calender</title>
          <link rel="canonical" href="https://www.vizfm.com/earningRelease" />
          <meta name="description" content="Earning Release Calender for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row><Col>Earning Release Calender</Col></Row>
          <Row>
            <Col><EarningReleaseListDisplay limt={100}/></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default EarningReleaseWrap;
